import React from 'react';
import { ColorPicker, Space } from 'antd';

const CustomColorPalette: React.FC = () => {
  return (
    <Space direction="vertical">
      <ColorPicker defaultValue="#076169" showText={(color) => <span> ({color.toHexString()})</span>} />
    </Space>
  );
};

export default CustomColorPalette;
